<div class="password-requirements" [class.active]="password()">
  <mat-progress-bar
    mode="determinate"
    [value]="progress()"
  ></mat-progress-bar>
  @for (requirement of requirements(); track trackRequirement($index, requirement)) {
  <div class="requirement animate__fadeInDownBig">
    <span class="icon">
      @if (requirement.isValid) {
      <mat-icon color="primary">done</mat-icon>
      }
      @if (!requirement.isValid) {
      <mat-icon color="warn">error</mat-icon>
      }
    </span>
    {{ requirement.message }}
  </div>
  }
</div>
